"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mailgun = exports.MailgunEvaluationRisk = exports.MailgunValidationResult = void 0;
const logger_1 = require("@linq/logger");
const Request_1 = require("./Request");
var MailgunValidationResult;
(function (MailgunValidationResult) {
    /** The recipient address is considered to be valid and should accept email. */
    MailgunValidationResult["Deliverable"] = "deliverable";
    /** The recipient address is considered to be invalid and will result in a bounce if sent to. */
    MailgunValidationResult["Undeliverable"] = "undeliverable";
    /** The recipient address is considered to be highly risky and will negatively impact sending reputation if sent to. */
    MailgunValidationResult["DoNotSend"] = "do_not_send";
    /** The validity of the recipient address cannot be determined as the provider accepts any and all email regardless of whether or not the recipient’s mailbox exists. */
    MailgunValidationResult["CatchAll"] = "catch_all";
    /** The validity of the recipient address cannot be determined for a variety of potential reasons. Please refer to the associated ‘reason’ array returned in the response. */
    MailgunValidationResult["Unknown"] = "unknown";
})(MailgunValidationResult = exports.MailgunValidationResult || (exports.MailgunValidationResult = {}));
var MailgunEvaluationRisk;
(function (MailgunEvaluationRisk) {
    MailgunEvaluationRisk["High"] = "high";
    MailgunEvaluationRisk["Medium"] = "medium";
    MailgunEvaluationRisk["Low"] = "low";
    MailgunEvaluationRisk["Unknown"] = "unknown";
})(MailgunEvaluationRisk = exports.MailgunEvaluationRisk || (exports.MailgunEvaluationRisk = {}));
class Mailgun {
    constructor(options) {
        if (!options.apiKey) {
            throw new Error('apiKey value must be defined!');
        }
        this.host = 'api.mailgun.net';
        this.username = 'api';
        this.apiVersion = 'v3';
        this.domain = options.domain;
        this.apiKey = options.apiKey;
        this.testMode = options.testMode;
        this.request = new Request_1.Request();
    }
    async send(email) {
        if (this.testMode) {
            logger_1.Logger.debug(`[testMode] sending email to ${email.to}`, email);
        }
        else {
            logger_1.Logger.debug(`sending email to ${email.to}`);
            const response = await this.request.post(`https://${this.host}/${this.apiVersion}/${this.domain}/messages`, email, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                auth: {
                    username: this.username,
                    password: this.apiKey,
                },
            });
            logger_1.Logger.debug(`[${response.status}]`, response.data);
        }
    }
    /**
     * Given an arbitrary email address, verifies email address based off defined checks.
     * @param email
     * @returns an object that provides information if an email is deliverable or not
     */
    async validate(email) {
        logger_1.Logger.debug(`validating ${email}`);
        const response = await this.request.get(`https://${this.host}/v4/address/validate`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            auth: {
                username: this.username,
                password: this.apiKey,
            },
            params: {
                address: email,
            },
        });
        logger_1.Logger.debug(`[${response.status}]`, response.data);
        return {
            email: response.data.address,
            isDisposableEmail: response.data.is_disposable_address,
            isRoleEmail: response.data.is_role_address,
            reason: response.data.reason,
            result: response.data.result,
            risk: response.data.risk,
        };
    }
}
exports.Mailgun = Mailgun;
//# sourceMappingURL=Mailgun.js.map